export interface Playbook {
  number: string
  title: string
  tagline: string
  description: string
  items: string[]
}

export const playbooks: Playbook[] = [
  {
    number: 'I',
    title: 'Diagnostic 360™',
    tagline: 'Organize your clinical evaluation before making treatment decisions.',
    description:
      'A structured framework created to help you review the key variables of a complex rehabilitation case.',
    items: [
      'Initial evaluation map',
      'Clinical signals checklist',
      'Functional assessment framework',
      'Case analysis worksheet',
      'Risk assessment matrix',
      'Diagnostic questions',
      'Evaluation sequence',
      'Pre-planning checklist',
    ],
  },
  {
    number: 'II',
    title: 'VDO Decision System™',
    tagline: 'Structure your thinking before making decisions about vertical dimension.',
    description:
      'A visual framework for organizing the variables involved in VDO assessment and rehabilitation planning.',
    items: [
      'VDO Decision Map',
      'Decision tree',
      'Assessment matrix',
      'Key variables checklist',
      'Planning worksheet',
      'Clinical attention signals',
      'Case hypothesis sheet',
      'VDO Quick Reference',
    ],
  },
  {
    number: 'III',
    title: 'Occlusion Control™',
    tagline: 'Turn complex occlusal variables into a structured evaluation process.',
    description:
      'Instead of trying to remember isolated concepts, organize them into a practical workflow.',
    items: [
      'Occlusal assessment map',
      'Occlusion checklist',
      'Variable matrix',
      'Analysis framework',
      'Decision tree',
      'Critical review points',
      'Common error library',
      'Planning worksheet',
    ],
  },
  {
    number: 'IV',
    title: 'Rehabilitation Flow™',
    tagline: 'Because the order of your decisions matters.',
    description:
      'A structured workflow for organizing complex rehabilitation cases from assessment through planning and review.',
    items: [
      'Complete treatment workflow',
      'Planning sequence',
      'Decision gates',
      'Pre-treatment checklist',
      'Review checklist',
      'Treatment planning sheet',
      'Priority matrix',
      'Critical control points',
      'Final Case Review',
    ],
  },
  {
    number: 'V',
    title: 'Clinical Risk Audit™',
    tagline: 'Identify the variables that deserve a closer look before moving forward.',
    description: 'A practical audit framework for reviewing critical aspects of complex cases.',
    items: [
      'Risk Scanner',
      'Risk classification system',
      'Clinical Red Flags',
      'Review checklist',
      'Priority matrix',
      'Common error library',
      'Case Audit',
      'Final Decision Sheet',
    ],
  },
  {
    number: 'VI',
    title: 'Complex Case Master™',
    tagline: 'Bring the entire system together.',
    description:
      'The complete workflow for organizing diagnosis, occlusion, VDO, rehabilitation planning and final review.',
    items: [
      'Complex Case Workflow',
      'Case Classification',
      'Diagnostic Map',
      'VDO Decision Map',
      'Occlusion Checklist',
      'Risk Audit',
      'Treatment Planning Sheet',
      'Decision Tree',
      'Final Case Review',
      'Quick Reference',
    ],
  },
]
